import { render } from "./Downloadables.vue?vue&type=template&id=49a4721a"
import script from "./Downloadables.vue?vue&type=script&lang=js"
export * from "./Downloadables.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__